import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, KeyValues3, KeyValues5, LocalService, RelationShipRole, SessionConfigType, Status, TriggeredEvent } from '../../../service/local.service';
import { SessionConfigComponent } from '../session-config/session-config.component';

@Component({
  selector: 'app-seats-queue',
  templateUrl: './seats-queue.component.html',
  styleUrls: ['./seats-queue.component.scss']
})
export class SeatsQueueComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["reservation", "table"]; isRedAlert = true; message = ''; queues: KeyValues5[];
  businessId = ''; maxBodyHeight = 0; relationShipType: InteractionType = InteractionType.Business;
  relationShipRole: RelationShipRole = RelationShipRole.EndCustomer; selectedUserId = ''; userName = ''; seatCount: number = null;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private cdr: ChangeDetectorRef, private billingManagementService: BillingManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    this.billingManagementService.getQueues(this.businessId).subscribe(result => {
      this.queues = result;
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onUserUpdated(e) {
    this.selectedUserId = e;
  }

  onAction(index, key = '') {
    this.message = '';
    switch (index) {
      case 1: {
        if (!this.userName && !this.selectedUserId) {
          this.message = this.localService.languageContent.reservation.customer_name_required;
        } else if (!this.seatCount) {
          this.message = this.localService.languageContent.reservation.seat_count_required;
        } else {
          let user = { v1: this.selectedUserId, v2: this.userName } as KeyValues3;
          this.billingManagementService.createQueue(this.businessId, this.seatCount, user).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onReset();
              this.onLoad();
            }
          });
        }
      } break;
      case 2: {
        this.billingManagementService.clearQueue(key).subscribe(result => {
          this.localService.showInformationByStatus(result);
          if (result == Status.Success || result == Status.NoChange) {
            this.queues = this.queues.filter(x => x.key != key);
          }
        });
      } break;
      case 3: {
        const modalRef = this.modalService.open(SessionConfigComponent);
        modalRef.componentInstance.businessId = this.businessId;
        modalRef.componentInstance.selectedQueueId = key;
        modalRef.componentInstance.sessionConfigType = SessionConfigType.Add;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.queues = this.queues.filter(x => x.key != key);
          }
        });
      } break;
    }
  }

  onReset() {
    this.userName = '';
    this.selectedUserId = '';
    this.seatCount = null;
  }
}
